import template from './primaryClaimEditor.html';
import controller from './primaryClaimEditor.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    staffUser: '<',
    position: '<',
    event: '<',
    primaryClaim: '<',
    canEdit: '<',
    required: '<',
    formName: '@',
  }
};

export default component;
